import * as Yup from "yup";
import { isValidPhone } from "./ValidationUtil";
import { ALERTAS_GENERICAS } from "./AlertasGenericas";

export const validationSchemaRequired = Yup.object().shape({
  requiredField: Yup.string().required(ALERTAS_GENERICAS.CAMPO_REQUERIDO),
});

export const validationSchemaEmail = Yup.object().shape({
  emailField: Yup.string()
    .email(ALERTAS_GENERICAS.CORREO_INVALIDO)
});

export const validationSchemaPhone = Yup.object().shape({
    phoneField: Yup.string().test(
    "phone",
    ALERTAS_GENERICAS.TELEFONO_INVALIDO,
    (value) => isValidPhone(value)
  ),
});

export const validationSchemaCustom = (callBack, errorMessage) =>
  Yup.object().shape({
    customField: Yup.string().test("custom", errorMessage, (value) =>
      callBack(value)
    ),
  });